import { Component, Input } from '@angular/core';
import { IonRouterOutlet, ModalController } from '@ionic/angular';
import { Socket } from 'ngx-socket-io';
import { MatchService } from '../../../_core/services/match.service';
import { Match } from '../../../_shared/models/match.model';
import { CreateMatchComponent } from '../create-match.component';
import { Preferences } from '@capacitor/preferences';

@Component({
  standalone: false,
    selector: 'app-create-match-button',
    templateUrl: './create-match-button.component.html',
    styleUrls: ['./create-match-button.component.scss'],
})
export class CreateMatchButtonComponent {
    @Input() match: Match;
    @Input() position: string;

    constructor(
        private modalController: ModalController,
        private routerOutlet: IonRouterOutlet,
        private matchService: MatchService,
        private socket: Socket
    ) { }

    async editMatch() {
        const modal = await this.modalController.create({
            component: CreateMatchComponent,
            presentingElement: this.routerOutlet.nativeEl,
            componentProps: {
                match: this.match,
                tieId: this.match.tie
            }
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();

        if (data) {
            let deviceId = (await Preferences.get({ key: 'deviceId' }))?.value;
            this.match = data.match;
            this.matchService.publishEdit(this.match);
            this.socket.emit('update-match', {matchUp: this.match, deviceId: deviceId});
        }
    }

}
